export const SUB_SERVICE_ORDER_STATUS = {
  ALL: -2,
  NEW: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FOR_TERMINATION: 3,
  TERMINATED: 4,
  CANCELLED: 5,
  WAITING_FOR_USER: 6,
  ERROR_OCCURED: 9,
}

export const SUB_SERVICE_ORDER_STATUS_BY_ID: Record<number, string> = {
  0: 'NEW',
  1: 'IN_PROGRESS',
  2: 'COMPLETED',
  3: 'FOR_TERMINATION',
  4: 'TERMINATED',
  5: 'CANCELLED',
  6: 'WAITING_FOR_USER',
  9: 'ERROR_OCCURED',
}
